import { render, staticRenderFns } from "./FeedsPicker.vue?vue&type=template&id=44d5194c&scoped=true"
import script from "./FeedsPicker.vue?vue&type=script&lang=js"
export * from "./FeedsPicker.vue?vue&type=script&lang=js"
import style0 from "./FeedsPicker.vue?vue&type=style&index=0&id=44d5194c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5194c",
  null
  
)

export default component.exports